<template>
  <div>
    <div
      class="mb-3 check-correct-option-info"
      v-if="selectedSlideIds.length > 1"
    >
      <i class="fas fa-info-circle" />
      <span class="pl-1">
        You are applying changes to {{ selectedSlideIds.length }} slides.
      </span>
    </div>

    <div class="audio-music-container slide-music">
      <div class="slide-music-disable" @click="openUpgradeAudioTrack" v-if="isPlanFree"></div>
      <div
        class="audio-track"
        v-click-outside="stopAllbmg"
      >
        <label class="label-audio-track label-option mt-2"><span>Slide audio</span>
          <img
            class="icon-audio-pro"
            src="@/assets/images/icon/audio-pro.svg"
            v-if="isPlanFree"
            @click="openUpgradeAudioTrack()"
          />
        </label>
        <div
          v-if="ctaUpgradeAudioTrack"
          class="cta-upgrade tooltip-audio-upgrade-now"
          v-click-outside="clickOutsideUpAudioTrack"
        >
          <span>You've just found a Pro feature!<br>Upgrade to use it.<br></span>
          <aha-button class="button-upgrade-now" variant="success" @click="handleModalUpgradeApply">
            Upgrade now
          </aha-button>
        </div>
        <div v-if="ctaUpgradeAudioTrack" class="upgrade-arrow upgrade-arrow_slide"></div>
        <span class="audio-track-description">Only play on this slide</span>
        <div class="mt-0 mb-2 slide-image-config" v-if="$store.getters.selectedSlide.audioLink">
          <div class="text-center image-box">
            {{ $store.getters.selectedSlide.audioName }}
          </div>
          <div class="audio-tag horizontal layout center-justified">
            <audio :src="$store.getters.selectedSlide.audioLink.url" controls ref="audio-config" />
          </div>
          <div class="horizontal layout center center-justified">
            <div
              class="horizontal layout center item-video-change change-audio-track"
            >
              <a>
                <i class="pr-2 far fa-file-audio" />
                <span @click="toggleSelectBgmMenuSection">Change audio track</span>
              </a>
            </div>
            <div class="horizontal layout center item-video-change">
              <a>
                <i class="pr-2 fas fa-trash-alt" />
                <span @click="deleteAudio()">Remove</span>
              </a>
            </div>
          </div>
        </div>
        <div
          class="mt-0 button-add-audio"
          v-if="!$store.getters.selectedSlide.audioLink || showSelectBgmMenuSection"
        >
          <div class="horizontal layout center">
            <div class="flex relative">
              <div
                class="input-select-track cursor-pointer
              horizontal layout center"
                @click="openBackgroundListMenu"
              >
                <i class="fas fa-music"></i>
                <div class="flex">
                  <span>Select</span>
                </div>
                <i class="fas fa-caret-down"></i>
              </div>
              <div
                class="audience-list-track"
                v-if="showBmgList"
                v-click-outside="closeBgmTrack"
              >
                <ul>
                  <li
                    class="horizontal layout center"
                    v-for="item in bmgList"
                    :key="item.title"
                    @click="selecAudio(item, $event)"
                  >
                    <div class="button-play-track" @click.stop="playDemo(item)">
                      <i
                        class="fas fa-play"
                        style="margin-left: 5%;"
                        v-if="!item.isPlay"
                      ></i>
                      <i class="fas fa-pause" v-if="item.isPlay"></i>
                    </div>
                    <div>
                      <span
                        :class="{'font-bold' : (slideAudioName === item.title)}"
                      >
                        {{ item.title }}
                      </span>
                    </div>
                    <div
                      v-if="slideAudioName === item.title"
                      class="icon-selected-track"
                    >
                      <img src="@/assets/images/elements/check-simple.svg">
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="select-track-or">
              or
            </div>
            <aha-button
              class="font-normal"
              @click="openModalUploadAudio"
            >
              Upload
            </aha-button>
          </div>

          <!--          <div class="block-body" v-if="$store.state.plan.group == 'free'">-->
          <!--            <p class="mb-3">-->
          <!--              Please upgrade your account to enable this feature.-->
          <!--            </p>-->
          <!--            <ButtonUpgrade />-->
          <!--          </div>-->
        </div>
      </div>

      <div class="form-group" v-if="$store.getters.selectedSlide.audioLink">
        <div class="form-check form-check-inline">
          <div
            class="custom-control custom-checkbox"
            :class="{ 'is-null': $store.getters.selectedSlide.audioAutoPlay == null }"
          >
            <input
              type="checkbox"
              class="custom-control-input"
              :disabled="$store.state.plan.group === 'free'
                || (!$store.getters.selectedSlide.audioShowControl && !$store.getters.selectedSlide.audioAudienceShowControl)
                || !$store.getters.selectedSlide.audioLink"
              id="presenter-autoplay"
              v-model="modelAudioAutoplay"
              @change="updateSlideByType(3)"
            >
            <label class="custom-control-label" for="presenter-autoplay">Autoplay</label>
            <span class="pl-1 title-table-presentation-tooltip">
              <b-button
                v-tooltip="'Automatically play the track (on your presenting screen)'"
                class="tooltip-btn"
              />
            </span>
          </div>
        </div>
        <div class="form-check form-check-inline">
          <div
            class="custom-control custom-checkbox"
            :class="{ 'is-null': $store.getters.selectedSlide.audioRepeat == null }"
          >
            <input
              type="checkbox"
              class="custom-control-input"
              :disabled="$store.state.plan.group == 'free'
                || !$store.getters.selectedSlide.audioLink"
              id="presenter-auto-repeat"
              v-model="modelAudioRepeat"
              @change="updateSlideByType(4)"
            >
            <label class="custom-control-label" for="presenter-auto-repeat">On repeat</label>
            <span class="pl-1 title-table-presentation-tooltip">
              <b-button
                v-tooltip="'Suitable for background tracks'"
                class="tooltip-btn"
              />
            </span>
          </div>
        </div>

        <div class="form-check form-check-inline form-check-inline-bottom">
          <div
            class="custom-control custom-checkbox"
            :class="{ 'is-null': $store.getters.selectedSlide.audioPlayOnAudience == null }"
          >
            <input
              type="checkbox"
              class="custom-control-input"
              :disabled="$store.state.plan.group == 'free'
                || !$store.getters.selectedSlide.audioLink"
              id="audience-playon"
              v-model="$store.getters.selectedSlide.audioPlayOnAudience"
              @change="updateSlideByType(5)"
            >
            <label
              class="custom-control-label"
              for="audience-playon"
            >Playable on audience's devices</label>
            <span class="pl-1 title-table-presentation-tooltip">
              <b-button
                v-tooltip="'Let your audience play the track on their devices'"
                class="tooltip-btn"
              />
            </span>
          </div>
        </div>
        <div class="sub-group" v-if="$store.getters.selectedSlide.audioPlayOnAudience">
          <div class="form-check form-check-inline">
            <div
              class="custom-control custom-checkbox"
              :class="{ 'is-null': $store.getters.selectedSlide.audioAudienceShowControl == null }"
            >
              <input
                type="checkbox"
                class="custom-control-input"
                :disabled="$store.state.plan.group == 'free'
                  || !$store.getters.selectedSlide.audioLink"
                id="audience-show-control"
                v-model="modelAudioShowControl"
                @change="updateSlideByType(6)"
              >
              <label
                class="custom-control-label"
                for="audience-show-control"
              >Show media controls</label>
              <span class="pl-1 title-table-presentation-tooltip">
                <b-button
                  v-tooltip="'Let the audience pause, resume, seek…'"
                  class="tooltip-btn"
                />
              </span>
            </div>
          </div>
        </div>
      </div>

      <UploadAudio
        v-if="showModalUploadAudio"
        @hideModal="hideModalUploadAudio"
        :type="''"
      />
    </div>

    <div class="audio-music-container presentation-music">
      <div class="slide-music-disable" @click="openUpgradePresentationAudioTrack" v-if="isPlanFree"></div>
      <div
        class="audio-track"
        v-click-outside="stopAllbmg"
      >
        <label class="label-audio-track label-option mt-2"><span>Presentation audio</span>
          <img
            class="icon-audio-pro"
            src="@/assets/images/icon/audio-pro.svg"
            v-if="isPlanFree"
            @click="openUpgradePresentationAudioTrack()"
          />
        </label>
        <div
          v-if="ctaUpgradePresentationAudioTrack"
          class="cta-upgrade tooltip-audio-upgrade-now"
          v-click-outside="clickOutsideUpPresentationAudioTrack"
        >
          <span>You've just found a Pro feature!<br>Upgrade to use it.<br></span>
          <aha-button class="button-upgrade-now" variant="success" @click="handleModalUpgradeApply">
            Upgrade now
          </aha-button>
        </div>
        <div v-if="ctaUpgradePresentationAudioTrack" class="upgrade-arrow upgrade-arrow_presentation"></div>
        <span class="audio-track-description">Autoplay throughout the presentation</span>
        <div class="mt-0 mb-2 slide-image-config" v-if="presentation.audioLink">
          <div class="text-center image-box">
            {{ presentation.audioName }}
          </div>
          <div class="audio-tag horizontal layout center-justified">
            <audio :src="presentation.audioLink.url" controls ref="presentation-audio-config" />
          </div>
          <div class="horizontal layout center center-justified">
            <div
              class="horizontal layout center item-video-change change-audio-track"
              :class="{'disabled': isDisableWhenNotOwner}"
            >
              <a>
                <i class="pr-2 far fa-file-audio" />
                <span
                  :class="{'disabled': isDisableWhenNotOwner}"
                  @click="toggleSelectPresentationBgmMenuSection"
                >Change audio track</span>
              </a>
            </div>
            <div
              class="horizontal layout center item-video-change"
              :class="{'disabled': isDisableWhenNotOwner}"
            >
              <a>
                <i class="pr-2 fas fa-trash-alt" />
                <span
                  :class="{'disabled': isDisableWhenNotOwner}"
                  @click="deletePresentationAudio()"
                >Remove</span>
              </a>
            </div>
          </div>
        </div>
        <div
          class="mt-0 button-add-audio"
          v-if="!presentation.audioLink || showSelectPresentationBgmMenuSection"
        >
          <div class="horizontal layout center">
            <div class="flex relative">
              <div
                class="input-select-track cursor-pointer
              horizontal layout center"
                :class="{'disabled': isDisableWhenNotOwner}"
                @click="openPresentationBackgroundListMenu"
              >
                <i class="fas fa-music"></i>
                <div class="flex">
                  <span>Select</span>
                </div>
                <i class="fas fa-caret-down"></i>
              </div>
              <div
                class="audience-list-track"
                v-if="showPresentationBmgList"
                v-click-outside="closePresentationBgmTrack"
              >
                <ul>
                  <li
                    class="horizontal layout center"
                    v-for="item in bmgList"
                    :key="item.title"
                    @click="selectPresentationAudio(item, $event)"
                  >
                    <div class="button-play-track" @click.stop="playDemo(item)">
                      <i
                        class="fas fa-play"
                        style="margin-left: 5%;"
                        v-if="!item.isPlay"
                      ></i>
                      <i class="fas fa-pause" v-if="item.isPlay"></i>
                    </div>
                    <div>
                      <span
                        :class="{'font-bold' : (presentationAudioName === item.title)}"
                      >
                        {{ item.title }}
                      </span>
                    </div>
                    <div
                      v-if="presentationAudioName === item.title"
                      class="icon-selected-track"
                    >
                      <img src="@/assets/images/elements/check-simple.svg">
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!--          <div class="block-body" v-if="$store.state.plan.group == 'free'">-->
          <!--            <p class="mb-3">-->
          <!--              Please upgrade your account to enable this feature.-->
          <!--            </p>-->
          <!--            <ButtonUpgrade />-->
          <!--          </div>-->
        </div>
      </div>
      <div
        class="mb-3 check-correct-option-info"
      >
        <i class="fas fa-info-circle" />
        <span class="pl-1">
          This won't play on slides with existing audio.
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapActions, mapGetters } from 'vuex'
import UploadAudio from '@/components/presentations/UploadAudio'
import Socket from '@/socket'
import ButtonUpgrade from '@/components/presentations/ButtonUpgrade'
import SlideApi from '@/api/slide'
import Constant from '@/constant'
import Util from '@/util'
import gaCategories from '@/constant/gaCategories'
import EventBus from '@/eventBus'
import bmgList from '@/constant/bgm'
import Config from '@/config'

const { PRESENTATION_EDITOR } = gaCategories

export default {
  name: 'AudioConfig',
  components: {
    UploadAudio,
    // eslint-disable-next-line vue/no-unused-components
    ButtonUpgrade,
  },
  data() {
    return {
      showModalUploadAudio: false,
      bmgList,
      showBmgList: false,
      showPresentationBmgList: false,
      showSelectBgmMenuSection: false,
      showSelectPresentationBgmMenuSection: false,
      ctaUpgradeAudioTrack: false,
      ctaUpgradePresentationAudioTrack: false,
    }
  },

  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      slideAudioName: (state) => state.slideActive.audioName,
      presentation: (state) => state.presentation,
      presentationAudioName: (state) => state.presentation.audioName,
      currentUser: (state) => state.currentUser,
      selectedSlideIds: (state) => state.selections.selectedSlideIds,
    }),
    ...mapGetters(['isPresenting', 'isDisableWhenNotOwner']),
    modelAudioAutoplay: {
      get() {
        return this.$store.getters.selectedSlide.audioAutoPlay || this.$store.getters.selectedSlide.audioAudienceAutoPlay
      },
      set(value) {
        this.$store.getters.selectedSlide.audioAutoPlay = value
      },
    },
    modelAudioRepeat: {
      get() {
        return this.$store.getters.selectedSlide.audioRepeat || this.$store.getters.selectedSlide.audioAudienceRepeat
      },
      set(value) {
        this.$store.getters.selectedSlide.audioRepeat = value
      },
    },
    modelAudioShowControl: {
      get() {
        return this.$store.getters.selectedSlide.audioShowControl || this.$store.getters.selectedSlide.audioAudienceShowControl
      },
      set(value) {
        this.$store.getters.selectedSlide.audioAudienceShowControl = value
      },
    },
    isPlanFree() {
      return !this.$store.state.plan || this.$store.state.plan.group === 'free'
    },
  },
  watch: {
    'slideActive.audioVolume': function (audioVolume) {
      if (this.$refs['audio-config'].audioVolume !== audioVolume) {
        this.$refs['audio-config'].volume = audioVolume
      }
    },
    'slideActive.audioMuted': function (audioMuted) {
      if (this.$refs['audio-config'].muted !== audioMuted) {
        this.$refs['audio-config'].muted = audioMuted
      }
    },
    '$store.getters.selectedSlide.audioLink': function (audioLink) {
      if (audioLink) {
        this.showSelectBgmMenuSection = false
        this.onAudioVolume()
      }
    },
    isPresenting(value) {
      if (value) {
        if (this.$refs['audio-config']) {
          this.$refs['audio-config'].pause()
        }
        if (this.$refs['presentation-audio-config']) {
          this.$refs['presentation-audio-config'].pause()
        }
      }
    },
  },

  mounted() {
    this.onAudioVolume()
    EventBus.$on('audio: open-audio-modal', () => {
      this.openModalUploadAudio()
    })
    this.triggerTrackingClickAudiobtn()
  },

  destroyed() {
    EventBus.$off('audio: open-audio-modal')
  },

  methods: {
    ...mapActions(['updateSlideActiveAction', 'updatePresentation']),
    openUpgradeAudioTrack() {
      this.ctaUpgradeAudioTrack = true
    },
    openUpgradePresentationAudioTrack() {
      this.ctaUpgradePresentationAudioTrack = true
    },
    clickOutsideUpAudioTrack() {
      this.ctaUpgradeAudioTrack = false
    },
    clickOutsideUpPresentationAudioTrack() {
      this.ctaUpgradePresentationAudioTrack = false
    },
    handleModalUpgradeApply() {
      this.ctaUpgradeAudioTrack = false
      this.$router.push('/apps/user-plan?redirect=/apps/user-plan')
    },
    onAudioVolume() {
      setTimeout(() => {
        const elAudio = this.$refs['audio-config']
        if (elAudio) {
          if (this.slideActive.audioVolume) {
            elAudio.volume = this.slideActive.audioVolume
          }
          if (this.slideActive.audioMuted) {
            elAudio.muted = this.slideActive.audioMuted
          }
          elAudio.onvolumechange = () => {
            if (elAudio.muted !== this.slideActive.audioMuted) {
              this.updateVolume(elAudio.volume, elAudio.muted)
              return
            }
            if (elAudio.volume === this.slideActive.audioVolume) return
            this.updateVolume(elAudio.volume)
          }
        }
      }, 250)
    },
    updateVolume: _.debounce(function debounceAudioVolume(audioVolume, muted) {
      const payload = {
        audioVolume,
      }
      if (muted !== null) {
        payload.audioMuted = muted
      }
      SlideApi.updateSlideById(this.slideActive.id, payload)
      this.updateSlideActiveAction(payload)
      Util.gaTrackEvent('Presentation Editor', 'Slide > Audio > Update Volumne', '')
    }, 300),

    toggleSelectBgmMenuSection() {
      this.showSelectBgmMenuSection = !this.showSelectBgmMenuSection
      const preDeleteAudioname = this.slideActive.audioName
      Util.ga4Track('Pick a sound track from the list', {
        eventAction: 'Audio Tab > Background music > Change audio track',
        eventCategory: 'Presentation Editor',
        eventLabel: 'Slide BMG',
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
        audioTrack: preDeleteAudioname,
      })
    },
    disableToggleLobbyMusic() {
      this.updatePresentation({
        isEnableQuizMusic: false,
      })
      this.updatePresentationApi({
        isEnableQuizMusic: false,
      })
    },
    toggleSelectPresentationBgmMenuSection() {
      if (this.isDisableWhenNotOwner) {
        return
      }
      this.showSelectPresentationBgmMenuSection = !this.showSelectPresentationBgmMenuSection
      this.disableToggleLobbyMusic()

      const preDeleteAudioname = this.slideActive.audioName
      Util.ga4Track('Pick a sound track from the list', {
        eventAction: 'Audio Tab > Background music > Change audio track',
        eventCategory: 'Presentation Editor',
        eventLabel: 'Presentation BMG',
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
        audioTrack: preDeleteAudioname,
      })
    },
    openModalUploadAudio() {
      if (this.isPlanFree) {
        this.openUpgradeAudioTrack()
        return
      }
      this.showModalUploadAudio = true
    },
    hideModalUploadAudio() {
      this.showModalUploadAudio = false
    },
    async deleteAudio() {
      const preDeleteAudioname = this.slideActive.audioName
      await this.updateSlide({
        audioLink: null,
        audioName: null,
      })
      Util.ga4Track('Remove audio track', {
        eventAction: 'Audio Tab > Background music > Remove an audio track',
        eventLabel: 'Slide BMG',
        eventCategory: 'Presentation Editor',
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
        audioTrack: preDeleteAudioname,
      })
    },
    async deletePresentationAudio() {
      if (this.isDisableWhenNotOwner) {
        return
      }
      const preDeleteAudioname = this.slideActive.audioName
      const payload = {
        audioLink: null,
        audioName: null,
      }
      this.updatePresentation(payload)
      await this.updatePresentationApi(payload)
      Util.ga4Track('Remove audio track', {
        eventAction: 'Audio Tab > Background music > Remove an audio track',
        eventLabel: 'Presentation BMG',
        eventCategory: 'Presentation Editor',
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
        audioTrack: preDeleteAudioname,
      })
    },

    async updateSlideByType(typeUpdate) {
      let payload = {}
      if (typeUpdate === 2) {
        payload = {
          audioShowControl: this.$store.getters.selectedSlide.audioShowControl,
        }
        if (!this.$store.getters.selectedSlide.audioShowControl) {
          this.$store.getters.selectedSlide.audioAutoPlay = true
          payload.audioAutoPlay = true
        }
        await this.updateSlide(payload)
      }
      if (typeUpdate === 3) {
        await this.updateSlide({
          audioAutoPlay: this.$store.getters.selectedSlide.audioAutoPlay,
          audioAudienceAutoPlay: this.$store.getters.selectedSlide.audioAutoPlay,
        })
      }
      if (typeUpdate === 4) {
        await this.updateSlide({
          audioRepeat: this.$store.getters.selectedSlide.audioRepeat,
          audioAudienceRepeat: this.$store.getters.selectedSlide.audioRepeat,
        })
      }
      if (typeUpdate === 5) {
        await this.updateSlide({
          audioPlayOnAudience: this.$store.getters.selectedSlide.audioPlayOnAudience,
        })
      }
      if (typeUpdate === 6) {
        payload = {
          audioAudienceShowControl: this.$store.getters.selectedSlide.audioAudienceShowControl,
          audioShowControl: this.$store.getters.selectedSlide.audioAudienceShowControl,
        }
        if (!this.$store.getters.selectedSlide.audioAudienceShowControl) {
          this.$store.getters.selectedSlide.audioAudienceAutoPlay = true
          this.$store.getters.selectedSlide.audioAutoPlay = true
          payload.audioAudienceAutoPlay = true
          payload.audioAutoPlay = true
        }
        await this.updateSlide(payload)
      }
      if (typeUpdate === 7) {
        await this.updateSlide({
          audioAudienceAutoPlay: this.$store.getters.selectedSlide.audioAudienceAutoPlay,
        })
      }
      if (typeUpdate === 8) {
        await this.updateSlide({
          audioAudienceRepeat: this.$store.getters.selectedSlide.audioAudienceRepeat,
        })
      }
    },

    async updateSlide(payload) {
      payload.presentationId = this.$store.state.presentation.id
      payload.accessCode = this.$store.state.presentation.uniqueAccessCode
      payload.socketId = Socket.getSocketId()
      payload.presenting = this.$store.getters.isPresenting || this.$store.getters.isBackstage

      await this.updateMultipleSlides(payload)

      const changedAttrs = []
      Constant.commonSlideAttributes.forEach((attr) => {
        if (payload[attr] !== undefined) {
          changedAttrs.push(attr)
        }
      })

      Util.gaTrackEvent(
        PRESENTATION_EDITOR,
        this.$store.getters.selectedSlides.length > 1
          ? `Audio Tab > Change ${changedAttrs.join(', ')} for multiple slides`
          : `Audio Tab > Change ${changedAttrs.join(', ')} for single slide`,
        `Presentation: ${this.$store.state.presentation.id}`,
      )
    },

    async updatePresentationApi(payload) {
      this.$store.dispatch('setSyncPresentation', 1)

      try {
        await this.$http.put(Config.api.updatePresentation + this.presentation.id, payload)
      } catch (error) {
        this.$store.dispatch('setSyncPresentation', 3)
        throw error
      }

      this.$store.dispatch('setSyncPresentation', 2)
    },

    async updateMultipleSlides(payload) {
      this.$store.dispatch('updateSlideActive', payload)
      if (!this.selectedSlideIds.length) {
        this.selectedSlideIds.push(this.$store.state.slideActive.id)
      }
      const slides = this.selectedSlideIds.map((id) => ({
        id,
        ...payload,
      }))

      try {
        this.$store.dispatch('setSyncPresentation', 1)
        await SlideApi.updateSlides({
          presentationId: this.$store.state.presentation.id,
          slides,
        })

        this.$store.getters.selectedSlides.forEach((slide) => {
          Constant.commonSlideAttributes.forEach((attr) => {
            if (payload[attr] !== undefined) {
              slide[attr] = payload[attr]
            }
          })
        })
        this.$store.dispatch('setSyncPresentation', 2)
      } catch (err) {
        this.$store.dispatch('setSyncPresentation', 3)
        throw err
      }
    },

    playDemo(item) {
      item.isPlay = !item.isPlay
      if (item.isPlay) {
        this.bmgList.forEach((a) => {
          if (a.title !== item.title) {
            if (a.audio) {
              a.audio.pause()
            }
            a.isPlay = false
          }
        })
        if (!item.audio) {
          item.audio = new Audio(item.url)
        } else {
          item.audio.currentTime = 0
        }
        item.audio.play().catch(() => {})
      } else if (item.audio) {
        item.audio.pause()
      }
      this.bmgList.push()
    },

    stopAllbmg() {
      this.bmgList.forEach((bmg) => {
        if (bmg.audio) {
          bmg.audio.pause()
          bmg.isPlay = false
        }
      })
      this.bmgList.push()
    },

    async selecAudio(item, event) {
      event.preventDefault()
      const payload = {}
      this.updateSlideActiveAction({
        audioName: item.title,
        audioLink: {
          name: item.title,
          url: item.url,
        },
      })
      payload.presentationId = this.$store.state.presentation.id
      payload.accessCode = this.$store.state.presentation.uniqueAccessCode
      payload.socketId = Socket.getSocketId()
      payload.presenting = this.$store.getters.isPresenting || this.$store.getters.isBackstage
      payload.audioLink = item.url
      payload.audioName = item.title
      this.showSelectBgmMenuSection = false
      await this.updateSlides(payload)
      this.showBmgList = false
      this.stopAllbmg()
      Util.ga4Track('Pick a sound track from the list', {
        eventAction: 'Audio Tab > Background music > Pick an audio track',
        eventLabel: 'Slide BMG',
        eventCategory: 'Presentation Editor',
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
        audioTrack: item.title,
      })
    },

    async selectPresentationAudio(item, event) {
      event.preventDefault()
      this.disableToggleLobbyMusic()

      const payload = {}

      this.updatePresentation({
        audioLink: {
          url: item.url,
          name: item.name,
        },
        audioName: item.title,
      })

      payload.presentationId = this.$store.state.presentation.id
      payload.accessCode = this.$store.state.presentation.uniqueAccessCode
      payload.socketId = Socket.getSocketId()
      payload.presenting = this.$store.getters.isPresenting || this.$store.getters.isBackstage
      payload.audioLink = item.url
      payload.audioName = item.title
      this.showSelectPresentationBgmMenuSection = false

      await this.updatePresentationApi(payload)

      this.showPresentationBmgList = false
      this.stopAllbmg()
      Util.ga4Track('Pick a sound track from the list', {
        eventAction: 'Audio Tab > Background music > Pick an audio track',
        eventCategory: 'Presentation Editor',
        eventLabel: 'Presentation BMG',
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
        audioTrack: item.title,
      })
    },
    async updateSlides(payload) {
      const instantPayload = {}
      Constant.commonSlideAttributes.forEach((attr) => {
        if (payload[attr] !== undefined) {
          instantPayload[attr] = payload[attr]
          // FIXME: Get & Set data should be the same format so we don't have to do this
          if (attr === 'audioLink') {
            instantPayload[attr] = {
              url: instantPayload[attr],
              name: payload.audioName,
            }
          }
        }
      })

      const appliedSlides = this.$store.getters.selectedSlides
      this.$store.dispatch('updateSlideActive', instantPayload)
      const slides = appliedSlides.map((slide) => ({
        id: slide.id,
        ...payload,
      }))

      try {
        this.$store.dispatch('setSyncPresentation', 1)
        await SlideApi.updateSlides({
          presentationId: this.$store.state.presentation.id,
          slides,
        })

        appliedSlides.forEach((slide) => {
          Constant.commonSlideAttributes.forEach((attr) => {
            if (instantPayload[attr] !== undefined) {
              slide[attr] = instantPayload[attr]
            }
          })
        })

        this.$store.dispatch('setSyncPresentation', 2)
      } catch (err) {
        this.$store.dispatch('setSyncPresentation', 3)
        throw err
      }
    },
    closeBgmTrack() {
      this.showBmgList = false
    },
    closePresentationBgmTrack() {
      this.showPresentationBmgList = false
    },
    triggerTrackingClickAudiobtn() {
      Util.ga4Track('Click to open the Audio tab', {
        eventAction: 'Open Audio Tab',
        eventCategory: 'Presentation Editor',
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
      })
    },
    openBackgroundListMenu() {
      if (this.isPlanFree) {
        this.openUpgradeAudioTrack()
        return
      }
      this.showBmgList = true
      Util.ga4Track('Open drop down menu', {
        eventAction: 'Audio Tab > Background music > Activate dropdown menu',
        eventLabel: 'Slide BMG',
        eventCategory: 'Presentation Editor',
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
      })
    },
    openPresentationBackgroundListMenu() {
      if (this.isDisableWhenNotOwner) {
        return
      }
      if (this.isPlanFree) {
        this.openUpgradePresentationAudioTrack()
        return
      }
      this.showPresentationBmgList = true
      Util.ga4Track('Open drop down menu', {
        eventAction: 'Audio Tab > Background music > Activate dropdown menu',
        eventLabel: 'Presentation BMG',
        eventCategory: 'Presentation Editor',
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.custom-control {
  display: block;

  .custom-control-label {
    cursor: pointer;
    font-style: initial;
  }
}
.sub-group {
  padding-left: 23px;
}

.audio-track {
  margin-bottom: 24px;
}

.form-check-inline {
  display: block;
  margin-bottom: 8px;
}

.slide-image-config {
  background-color: #f2f2f2;
  .image-box {
    margin-top: 7px;
    font-weight: bold;
    img {
      max-width: 150px;
      max-height: 90px;
    }
  }

  a {
    margin-top: 16px;
  }
}
.item-video-change {
  margin-right:10px;
  &.change-audio-track {
    margin-right: 32px;
  }
}
.audio-tag {
  width: 100%;
  margin-top: 11px;

  audio {
    border: 2px solid #ccc;
    border-radius: 30px;
    width: 100%;
    height: 32px;
    max-width: 380px;
  }
}

.is-null {
  font-style: italic;
}

.input-select-track {
  border: 1px solid #D3D7E1;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.3s ease-in-out;
  background: #ffffff;
  &:hover {
    background-color: rgba(249, 251, 255, 1);
    border-color: #4f9af2;
  }
  &:focus {
    border-color: #4f9af2;
  }
  .flex {
    margin: 0 8px;
  }
}

.select-track-or {
  margin: 0 8px;
}

.audience-list-track {
  background-color: #fff;
  border: 1px solid #D3D7E1;
  box-shadow: 3px 3px 5px rgba(211, 215, 225, 0.42);
  border-radius: 4px;
  padding: 4px;
  max-height: 375px;
  overflow-y: auto;
  position: absolute;
  top: 44px;
  width: 100%;
  z-index: 10;

  ul {
    padding-left: 0;
    margin-bottom: 0;
    li {
      padding: 8px;
      cursor: pointer;
      .button-play-track {
        width: 40px;
        height: 40px;
        text-align: center;
        background-color: #EFF1F7;
        border-radius: 40px;
        line-height: 40px;
        margin-right: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .icon-selected-track {
        @apply flex justify-center items-center;
        width: 20px;
        margin-left: auto;
      }
      &:hover {
        background-color: #F0F4FA;
        .button-play-track {
          background-color: #fff;
        }
      }
    }
  }
}

.slide-music {
  border-top-width: 0;
  border-left-width: 0;
  border-right-width: 0;
  border-bottom: 1px solid #EBEBEB;
}

.audio-track-description {
  display: block;
  margin-bottom: 16px;
  color: #707070;
}

.label-audio-track {
  color: #282E3E;
  display: flex;
  align-items: center;

  span {
    margin-right: 5px;
  }
}

.slide-music {
  .form-check-inline-bottom {
    margin-bottom: 12px;
  }
}

.presentation-music {
  .label-audio-track {
    margin-top: 24px !important;
  }

  .audio-track {
    margin-bottom: 12px;
  }
}

.audio-music-container {
  position: relative;
  //.slide-music-disable{
  //  position: absolute;
  //  top: 15%;
  //  left: 0;
  //  width: 100%;
  //  height: 85%;
  //  z-index: 1;
  //}
}

.cta-upgrade {
  @apply bg-secondary-100 absolute w-60 p-3 rounded z-50;
  top: 2rem;
  left: calc(50% - 150px);
  font-family: 'Nunito', sans-serif;
  padding-bottom: 16px;

  div,
  span {
    @apply text-base-0 text-sm;
  }

  div {
    @apply font-bold;
  }

  span {
    @apply font-normal mt-1;
  }
}

.upgrade-arrow {
  width: 0;
  height: 0;
  border-width: 0 8px 8px 8px;
  border-color: transparent transparent rgba(40, 46, 62, var(--tw-bg-opacity)) transparent;
  border-style: solid;
  position: absolute;
  z-index: 1;
  top: 1.6rem;

  &.upgrade-arrow_presentation {
    left: calc(50% - 47px);
  }

  &.upgrade-arrow_slide {
    left: calc(50% - 97px);
  }
}

.tooltip-audio-upgrade-now {
  .button-upgrade-now {
    margin-top: 12px;
  }
}

.icon-audio-pro {
  &:hover {
    cursor: pointer;
  }
}

</style>
